module.exports = __webpack_public_path__ + "img/team-4.5e2f4479.jpg";